// extracted by mini-css-extract-plugin
module.exports = {"head":"Expandable_head__RK_b6","title":"Expandable_title__1ePkp","svg":"Expandable_svg__3zn-r","activeSvg":"Expandable_activeSvg__2BKnK"};